import PropTypes from "prop-types";
import React from "react";
import { Modal, ModalBody } from "reactstrap";
// import comuni from "../../../../assets/images/communications.png"
import comuni from "../../../../../assets/images/communications.png"


const Removebackground = ({ show, submitButton, onCloseClick }: any) => {
    return (
        <Modal isOpen={show} toggle={onCloseClick} centered={true}>
            <ModalBody className="py-3 px-3">
                <div className="d-flex justify-content-between align-items-center ">
                    <h4>Remove background</h4>
                    <i className='bx bx-x fs-2 cursor-pointer' data-testing-Id="closeIconbackground_mediaCenter" style={{ color: "#CACACA" }} onClick={onCloseClick}></i>
                </div>
                <div className="ImageRow d-flex justify-content-start align-items-center flex-wrap gap-3 my-4">
                    <div className="mainImageDv">
                        <div style={{ width: '120px', height: 'auto', maxHeight: '130px', minHeight: "110px", border: "1px solid #CACACA" }} className=" mb-2 p-2 rounded">
                            <img
                                src={comuni}
                                className="img-fluid d-block w-100 h-100"
                            />
                        </div>
                        <p
                            className="m-0 text-center fs-6"
                            style={{
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                width: '110px',

                            }}
                        >
                            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Amet, quae?
                        </p>
                    </div>
                </div>
                <div className="d-flex justify-content-between align-items-center ">
                    <p className="m-0 p-0">1 Images successful</p>
                    <div>
                        <button className="btn btn-outline-dark me-3 lightGrayButton" type="submit" data-testing-Id="cancelButtonremoveBackgrounf_mediaCenter" onClick={onCloseClick}>Cancel</button>
                        <button type="button" className="btn btn-secondary " data-testing-Id="submitButton_mediaCenter">Submit</button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

Removebackground.propTypes = {
    onCloseClick: PropTypes.func,
    submitButton: PropTypes.func,
    show: PropTypes.any,
};

export default Removebackground;